import React, { Component } from 'react';
import GreenButtonHeader from './misc/GreenButtonHeader';
import AgeList from './ChooseAge/AgeList';

export class ChooseAge extends Component {
  continue = e => {
    e.preventDefault();
    this.props.nextStep();
  }

  goToHomepage = () => {
    window.location.href = "http://web.wholechildapp.com/"
  }
  render() {
    return (
      <div>
        <div className="header-chooseage">
          <div className="bar">
            <img className="headerLogo" src={require("../assets/imgs/logo-blue.png")} alt="logo" />
            <p className="headerText">Choose your Child's Age to Begin Test</p>
            <GreenButtonHeader nextStep={this.goToHomepage} name="GO TO HOMEPAGE" />
          </div>

          <AgeList
            handleChange={this.props.handleChange}
            handleChangeForced={this.props.handleChangeForced}
            nextStep={this.continue}
          />
        </div>
      </div>
    )
  }
}

export default ChooseAge